import React,{useEffect, useState}from 'react'
import Main from '../../cpn/Main'
import { Table,Space, message, } from 'antd';
import { useBnsYiXiangKeHuDelMutation, useBnsYiXiangKeHuListQuery } from '../../store/ReactWebSiteApi';
import ClientEdit from './ClientEdit';
import ModalDel from '../../cpn/ModalDel';
import ClientCheck from './ClientCheck';
import ClientAdd from './ClientAdd';
function ClientList() {       
    const [list, setList] = useState();    
    const {data, isSuccess} = useBnsYiXiangKeHuListQuery({byxkh_e_id:localStorage.getItem('e_id')},{refetchOnMountOrArgChange:1});    
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {byxkh_id:key,byxkh_name,byxkh_ctime,byxkh_cname,byxkh_bg_name,byxkh_dept_id,byxkh_dept_name,byxkh_meijie_name,byxkh_riqi,byxkh_content} = item;
                    return item = {key,byxkh_name,byxkh_ctime,byxkh_cname,byxkh_bg_name,byxkh_dept_id,byxkh_dept_name,byxkh_meijie_name,byxkh_riqi,byxkh_content}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.byxkh_ctime;
                    let bTimeString = b.byxkh_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'byxkh_name',
            title: '客户名称',            
            dataIndex:'byxkh_name',
            render:(_,record) => {
                return  <ClientCheck
                            byxkh_name={record.byxkh_name}
                            byxkh_id={record.key}
                        />
            }
        },
        {
            key: 'byxkh_meijie_name',
            title: '媒介',            
            dataIndex: 'byxkh_meijie_name',
            
        },
        {
            key: 'byxkh_riqi',
            title: '日期',            
            dataIndex: 'byxkh_riqi',
            
        },
        {
            key: 'byxkh_bg_name',
            title: '产品',  
            dataIndex:'byxkh_bg_name'          
        },   
        {
            key: 'num',
            title: '编号',            
            dataIndex: 'key',
            
        },
        {
            key: 'byxkh_dept_name',
            title: '部门',            
            dataIndex: 'byxkh_dept_name',
            
        },
        {
            key: 'byxkh_content',
            title: '备注',            
            dataIndex: 'byxkh_content',
            
        },
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>{record.byxkh_ctime + record.byxkh_cname}</>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>
                        <ClientEdit
                            byxkh_id={record.key}
                        />            
                        <ModalDel onOk={() => {
                            del({byxkh_id:record.key}).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('删除成功！')                                                                              
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('删除失败！'+res.data.Message)
                                }
                            })
                        }} />   
                    </Space>
                </>
            }
        },
    ]   
    //删除
    const [del] = useBnsYiXiangKeHuDelMutation()
    return (
        <Main t1='推广'  t2='意向客户'>
            <Space size='large'>
                <ClientAdd />      
            </Space> 
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}} 
                style={{marginTop:"20px"}}
            />
        </Main>
    )
}

export default ClientList